module.exports = __webpack_public_path__ + "static/media/FXgAZNhaMAADLED.7d5215b9.webp";